import { Route } from '@framework/ui/core/router/TypedRoute.tsx';
import { Switch } from 'react-router';
import { NotFoundPage } from '../errors/not-found/NotFoundPage.tsx';
import { DossierPage } from './detail/DossierPage.tsx';
import { DossierListPage } from './list/DossierListPage.tsx';

export default function DossierRoutes() {
  return (
    <Switch>
      <Route path="/pratiche/:id" component={DossierPage} exact />
      <Route path="/pratiche" component={DossierListPage} exact />
      {/* Il modulo è montato non-exact sul prefisso: senza fallback i path
          senza route dedicata restano bianchi */}
      <Route component={NotFoundPage} />
    </Switch>
  );
}
